import Locales from '@spa/shared/constants/locales';
import { SERVICES_FEATURES } from '@spa/shared/constants/services-features';
import { PROPERTY_RULES } from '@spa/shared/constants/property-rules';
import { UNIT_TYPES } from '@spa/shared/constants/unitTypes';
import UnavailableFeatureIcon from '@spa/shared/svg/unavailable-feature';

export const translateFromLanguage = (translations, language = 'en') => {
  const locale = Locales[language.toUpperCase()];

  return translationFromLocale(translations, locale);
};

export const translationFromLocale = (translations = [], locale = Locales.EN) => {
  if (!translations) {
    return '';
  }

  const text = translations.length ? translations[0].text : '';
  const translation = translations.find(({ locale_code }) => locale_code === locale);

  return translation ? translation.text : text;
};

export const findBaseUnit = (unit, id) =>
  unit.id === id || (unit.subunits && unit.subunits.find(subunit => findBaseUnit(subunit, id)));

export const findUnit = (units, id, unitAcc = null) =>
  units.reduce((acc, unit) => {
    if (unit.id === id) {
      return unit;
    }

    return unit.subunits ? findUnit(unit.subunits, id, acc) : acc;
  }, unitAcc);

export const featuresReducer = (acc, feature, serviceFeatures = SERVICES_FEATURES) => {
  const converted = getFeatureWithAssertedIcon(feature, serviceFeatures);
  if (!converted) {
    return acc;
  }

  return [...acc, converted];
};

export const getFeatureWithAssertedIcon = (feature, serviceFeatures) => {
  if (!serviceFeatures[feature.Code]) {
    return null;
  }

  const convertedFeature = feature.Exists
    ? serviceFeatures[feature.Code]
    : serviceFeatures[`${feature.Code}-not`] ?? { ...serviceFeatures[feature.Code], Component: UnavailableFeatureIcon };

  return { ...convertedFeature, exists: feature.Exists };
};

export const rulesReducer = (acc, rule) => {
  const converted = !rule.exists && PROPERTY_RULES[rule.code];
  if (!converted) {
    return acc;
  }

  return [...acc, converted];
};

export const findPhotosByUnit = (unit, allPhotos = []) =>
  unit.photos
    ? unit.photos.reduce((acc, unitPhoto) => {
        const photo = allPhotos.find(photo => unitPhoto.id === photo.id);
        if (!photo) {
          return acc;
        }

        return [...acc, { ...unitPhoto, ...photo }];
      }, [])
    : [];

export const getAllFeatures = (unit, allFeatures = []) => {
  if (!unit.subunits) {
    return unit.features ? [...allFeatures, ...unit.features] : allFeatures;
  }

  return unit.subunits.reduce((acc, { features, subunits }) => {
    if (subunits?.length) {
      return getAllFeatures({ subunits, features }, acc);
    }

    return features ? [...acc, ...features] : acc;
  }, allFeatures);
};

export const findUnitType = (unit, unitType) =>
  !!(
    unit.subunits &&
    unit.subunits.some(subunit => {
      if (subunit.type_code !== unitType && subunit.subunits && subunit.subunits.length) {
        return findUnitType(subunit);
      }

      return subunit.type_code === unitType;
    })
  );

export const getUnitCountInFloor = (floor, type) =>
  floor.units.filter(({ type_code: unitCode }) => unitCode === type).length;

export const getUnitCount = (floors, type) => floors.reduce((_, floor) => getUnitCountInFloor(floor, type), 0);

export const getSubunitCountInUnit = (unit, type) =>
  unit.subunits.filter(({ type_code: unitCode }) => unitCode === type).length;

export const getNumberOfBedrooms = (floors, typologyBedrooms) =>
  typologyBedrooms || getUnitCount(floors, UNIT_TYPES.BEDROOM);

export const getNumberOfBathrooms = (floors, typologyBathrooms) =>
  typologyBathrooms || getUnitCount(floors, UNIT_TYPES.BATHROOM) + getUnitCount(floors, UNIT_TYPES.WC);
